import { useMutation } from '@gogame/query';

import { editAnnotation } from '../../sources/annotations';
import { update } from '../queryKeyFactory';

export const useUpdateAnnotation = () => {
  const updateMutation = useMutation(update(), editAnnotation, {
    successMessage: () => `Annotation updated`,
  });

  return [updateMutation.mutateAsync, updateMutation];
};
